<template>
<section :class="['steps-wrp', {'supplier-steps': mode === 'supplier'}]">
  <div 
    v-for="(item, idx) in stepsData"
    :key="idx"
    :class="['item', {'flex2': (idx !== stepsData.length - 1)}]"
  >
    <div :class="['label', {'active': (idx === active)}, {'edited': item.edited}]">
      <template>
        <span v-if="!item.edited" :class="['num']">{{idx + 1}}</span>
        <span v-else class="edited-circle"></span>
      </template>
      <span>{{item.label}}</span>
    </div>
    <div v-if="idx !== (stepsData.length - 1)" :class="['line', {'active': active === idx+1}]"></div>
  </div>
</section>
</template>

<script>
export default {
  components: {
  },
  props: {
    active: {
      type: Number,
      default: 0
    },
    mode: {
      type: String,
      default: ''
    },
    stepsData: {
      type: Array,
      default(){
        return []
      }
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
$gray: #d4d0d0;
$distriColor:#F98844;
$supplierColor: #396CF3;
.supplier-steps {
  .item .label .edited-circle {
    border: 1px solid $supplierColor !important;
    &:after {
      border-bottom: 1px solid $supplierColor !important;
      border-right: 1px solid $supplierColor !important;
    }
  }
  .line.active {
    background: $supplierColor !important;
  }
  .label.active .num{
      background: $supplierColor !important;
  }
}
.steps-wrp {
  display: flex;
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 10px;
    margin-bottom: 20px;
    &.flex2 {
      flex: 2;
    }
    .label {
      margin-right: 10px;
      color: $gray;
      .edited-circle {
        width: 18px;
        height: 18px;
        display: inline-block;
        line-height: 18px;
        text-align: center;
        border-radius: 50%;
        vertical-align: middle;
        border: 1px solid $distriColor;
        margin-right: 6px;
        position: relative;
        &:after {
          content: ' ';
          display: inline-block;
          width: 4px;
          height: 8px;
          border-bottom: 1px solid $distriColor;
          border-right: 1px solid $distriColor;
          transform: rotate(45deg);
          position: absolute;
          left: 6px;
          top: 3px;
        }
      }
    }
    .label.active, .label.edited {
      color: #606266;
    }
    .line {
      flex-grow: 1;
      height: 1px;
      background: $gray;
      border-radius: 1px;
      opacity: 0.5;
      &.active {
        background: $distriColor;
      }
    }
    .num {
      display: inline-block;
      width: 18px;
      height: 18px;
      background: #fff;
      border: 1px solid $gray;
      border-radius: 50%;
      line-height: 18px;
      text-align: center;
      color: $gray;
      margin-right: 6px;
    }
    .label.active .num{
      background: $distriColor;
      color: white;
      border: none;
    }
  }
}
</style>